import { RVNestedRoutingPage } from "@regal-voice/ui";

import { ADSettingsPaths } from "../AgentDesktop/paths";
import CommunicationTemplates from "./CommunicationTemplates";
import CommunicationTemplatePage from "./Pages/CommunicationTemplatePage/CommunicationTemplatePage";
import { CommunicationTemplatesPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

export const communicationTemplatesRoute: RegalRouteObject = {
    path: `${ADSettingsPaths.templates}/*`,
    element: <RVNestedRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <CommunicationTemplates />,
        },
        {
            path: CommunicationTemplatesPaths.templatesFormNew,
            element: <CommunicationTemplatePage />,
        },
        {
            path: CommunicationTemplatesPaths.templatesFormEdit,
            element: <CommunicationTemplatePage />,
        },
    ],
};
